module.exports = __webpack_public_path__ + "media/images/sp/items/album/denim-2c8ceb0aa7eabef131a350f6560f6fd5.jpg";